import type { LinkProps } from "@tanstack/react-router";
import { Activity, BarChart3, Bot, Building2, LayoutDashboard, PoundSterling, Server, Siren, UserPlus, Users } from "lucide-react";
import type { ReactNode } from "react";

export interface AdminNavItem {
  key: "overview" | "servers" | "operations" | "incidents" | "ai-ops" | "tenants" | "accounts" | "signups" | "money" | "usage";
  to: LinkProps["to"];
  label: string;
  icon: ReactNode;
  group: "Platform" | "Customers" | "Business" | null;
  exact?: boolean;
  /** Keyboard shortcut after pressing g, inside /admin. */
  key2: string;
}

/** Platform admin navigation (founder only). Grouped as the sidebar shows it. */
export const adminNav: AdminNavItem[] = [
  { key: "overview", to: "/admin", label: "Overview", icon: <LayoutDashboard />, group: null, exact: true, key2: "o" },
  { key: "servers", to: "/admin/servers", label: "Servers", icon: <Server />, group: "Platform", key2: "s" },
  { key: "operations", to: "/admin/operations", label: "Builds and deploys", icon: <Activity />, group: "Platform", key2: "b" },
  { key: "incidents", to: "/admin/incidents", label: "Incidents", icon: <Siren />, group: "Platform", key2: "i" },
  { key: "ai-ops", to: "/admin/ai-ops", label: "AI operations", icon: <Bot />, group: "Platform", key2: "k" },
  { key: "tenants", to: "/admin/tenants", label: "Tenants", icon: <Building2 />, group: "Customers", key2: "t" },
  { key: "accounts", to: "/admin/accounts", label: "Accounts", icon: <Users />, group: "Customers", key2: "a" },
  { key: "signups", to: "/admin/signups", label: "Signups", icon: <UserPlus />, group: "Customers", key2: "w" },
  { key: "money", to: "/admin/money", label: "Money", icon: <PoundSterling />, group: "Business", key2: "m" },
  { key: "usage", to: "/admin/usage", label: "Usage", icon: <BarChart3 />, group: "Business", key2: "u" },
];
